<template>
  <div
    :class="`tw-flex tw-gap-[15px] tw-items-center ${
      disabled ? 'tw-pointer-events-none' : ''
    }`"
  >
    <div
      :id="idPercentInput"
      :class="[
        'tw-flex tw-justify-between tw-items-center tw-cursor-text filter-modal-input',
        isInvalid ? '!tw-border-[red]' : '',
        classInput,
      ]"
      @click="(inputRef as any)?.focus()"
    >
      <div class="tw-flex tw-items-center">
        <input
          :id="`${idPercentInput}-input`"
          ref="inputRef"
          v-model="currentValue"
          :type="type"
          :placeholder="hintText"
          :class="[
            'tw-max-w-[68px] tw-min-w-[10px]',
            classText,
            isInRange100 ? '!tw-w-[20px]' : 'tw-w-full',
          ]"
          :disabled="disabled"
          v-bind="inputProps"
          @input="updateInput"
          @focus="emit('focus')"
          @focusout="emit('focusout', currentValue)"
          @blur="emit('on:blur')"
          @paste.prevent
        />
        <span ref="mirror" class="invisible absolute whitespace-pre"></span>
        <span
          v-if="hintText"
          :class="[
            currentValue || currentValue?.toString() === '0' ? 'show' : '',
            classText,
          ]"
          >%</span
        >
      </div>
      <button
        v-if="currentValue !== '' && isShowButtonClear"
        id="close-iten"
        type="button"
        class="tw-bg-transparent tw-border-none tw-outline-none"
        @click="clearData"
      >
        <CloseBoxIcon :size="15" color="#FFF" color-x="#DBDBDB" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import CloseBoxIcon from "../svgs/closeBoxIcon.vue";

const emit = defineEmits([
  "update:modelValue",
  "focusout",
  "on:blur",
  "clearValue",
  "focus",
]);
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  hintText: {
    type: String,
    required: true,
  },
  value: {
    type: [Number, String],
    default: 0,
    validator: (val) =>
      typeof val === "number" || typeof val === "string" || val === null,
  },
  classText: {
    type: String,
    default: "tw-text-[#B7B7B7]",
  },
  classInput: {
    type: String,
    default: "tw-text-[11px] tw-font-medium",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isInRange100: {
    type: Boolean,
    default: false,
  },
  idPercentInput: {
    type: String,
    default: "",
  },
  isShowButtonClear: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "text",
  },
  inputProps: {
    type: Object,
    default: () => ({}),
  },
  isInvalid: {
    type: Boolean,
    default: false,
  },
  fixed: {
    type: Number,
    default: 1,
  },
});

const inputRef: any = ref(null);
const mirror: any = ref(null);
const currentValue = ref(props.value || props.value === 0 ? props.value : "");

onMounted(() => {
  resizeInput();
});

watch(
  () => props.value,
  () => {
    currentValue.value = props.value || props.value === 0 ? props.value : "";
  },
);

watch(
  () => currentValue.value,
  () => {
    resizeInput();
  },
);

const clearData = () => {
  currentValue.value = "";
  emit("update:modelValue", "");
  emit("clearValue", "");
};

const isMoreThanTwoFixed = (value: string) => {
  const n = value.length;
  const index = value.indexOf(".");
  return index !== -1 && (index < n - props.fixed - 1 || props.fixed === 0);
};

const isCheckInRange100 = (value: string) => {
  const num = parseFloat(value);
  return num < 0 || num > 100;
};

const updateInput = (e) => {
  if (
    isNaN(e.target.value) ||
    (props.isInRange100 && isCheckInRange100(e.target.value)) ||
    isMoreThanTwoFixed(e.target.value)
  ) {
    currentValue.value = currentValue.value.toString().slice(0, -1);
    return;
  }
  emit("update:modelValue", e.target.value);
};

const resizeInput = () => {
  //   if (mirror.value && inputRef.value) {
  //     mirror.value.textContent = currentValue.value || "";
  //     inputRef.value.style.width = mirror.value.offsetWidth + 2 + "px";
  //   }
};
</script>

<style scoped lang="scss">
.filter-modal-input {
  height: 38px;
  min-width: 53px;
  max-width: 53px;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #eff0f1;
  background-color: #ffffff;
}

.filter-modal-input input {
  border: none;
  outline: none;
  width: 100%;
  font-family: "Poppins";
  font-size: inherit;
  font-style: normal;
  font-weight: inherit;
  line-height: 130%;
  text-align: center;
  background-color: transparent;
}

input::placeholder {
  color: #b7b7b7;
  text-align: left;
  font-family: "Poppins";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

input:focus::placeholder {
  color: transparent;
}

.filter-modal-input span {
  font-family: "Poppins";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  width: 0px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.filter-modal-input span.show {
  opacity: 1;
  width: auto;
}
.filter-modal-input {
  width: 117px;
  max-width: none;
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
}
</style>
